<template>
  <div id="layout-preview">
    <div class="title" v-if="is_start">
      <carousel :per-page="1" :mouse-drag="true" :autoplay="true" :loop="true" :autoplayTimeout="8000"
      paginationColor="#AFBCDE" paginationActiveColor="#485c92" @page-change="pageChange">
        <slide v-for="slide in slides" v-html="slide.body"></slide>
      </carousel>
      <p v-if="isIE">ただいまインターネットエクスプローラーを使ってのご注文に不具合が出ております。
        他ブラウザにてご注文お願いします。</p>
    </div>
    <div v-if="!is_start" id="preview-area">
      <div id="layer_front_container">
        <div id="layer_front">
          <product :reverse="reverse" ref="product"></product>
        </div>
      </div>

      <div id="layer_back" @click="setReverse(!reverse)">
        <button class="reverse"></button>
        <product :reverse="!reverse"></product>
      </div>

      <vk-button class="size-list" @click="openSizeModal()">サイズ一覧</vk-button>
      <div class="price" @click="openPriceModal()">{{ basePrice() | currency}}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import modal from '../service/modal';
import Product from './preview/Product.vue'
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'layout-preview',
  components: {
    Product,
    Carousel,
    Slide
  },
  computed: {
    ...mapState(['cart']),
    ...mapGetters(['basePrice']),
    is_start(){
      if (this.cart.design){
        return false;
      } else {
        return true;
      }
      return !this.cart.figure;
    },
    reverse(){
      return this.$store.state.reverse;
    },
    isIE(){
      let userAgent = window.navigator.userAgent.toLowerCase();
      if(userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) {
        return true;
      } else {
        return false;
      }
    }
  },
  data () {
    return {
      product_scale: 1.9,
      slides: []
    }
  },
  created () {
    this.$store.commit('setLoading');
    window.axios.get('/pages/top.json').then(response => {
      this.slides = response.data.pages;
      this.$store.commit('resetLoading');
    });
  },
  methods: {
    setReverse(reverse){
      this.$store.commit('setReverse', reverse);
    },
    openSizeModal () {
      modal.sizeModal({header: 'サイズ', message: this.cart.figure.size_comment});
    },
    openPriceModal () {
      modal.priceModal({header: '料金明細', });
    },
    pageChange(page) {
      // console.log(page);
    }
  }
}
</script>

<style>
  #layer_front .picture{
    position: absolute;top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0;
    width: 230px;
    height: 193px;
  }
  #layer_front > .product{
    transition: all 1s ease;
    transform-origin: top left;
  }
  #layer_back .picture{
    position: absolute;
    top: 50px;
    left: 2px;
    right: 0;
    bottom: 0;
    margin: 0;
    width: 115px;
    height: 95px;
  }
</style>

<style lang="scss" scoped>
  #layout-preview img.image {
    position: absolute;
    top: 36px;
    left: 50%;
    margin-left: -115px; }
  #layout-preview button.reverse {
    border: 0;
    background-image: url(http://uni.chapeu.co.jp/src/assets/hanten.svg);
    background-repeat: no-repeat;
    background-size: 100%;
    width: 44px;
    height: 44px;
  }
  #layout-preview .price {
    position: absolute;
    background-color: #151d66;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    color: #fff;
    width: 124px;
    height: 30px;
    top: 193px;
    right: 0px;
    line-height: 30px;
    z-index: 999;
  }
  .size-list{
    position: absolute;
    background-color: #fff;
    border-radius: 10px;
    border-color: #151d66;
    color: #151d66;
    width: 124px;
    height: 30px;
    top: 160px;
    right: 0px;
    line-height: 30px;
  }

  #layer_front_container{
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0 auto;
    overflow: auto;
    height: 227px;
  }
  #layer_front{
    position: relative;
  }
  #layer_back{
    position: absolute;
    top: 10px;
    right: 0px;
    bottom: 0;
    margin: 0 auto;
    width: 120px;
    height: 145px;
    border: 1px solid #151d66;
    border-radius: 10px;
    background-color: rgba(255,255,255,.5);
  }
  .uk-modal-footer .uk-button{
    background-color:#151d66;
    border:0;
  }
  .uk-modal-footer .uk-button:hover{
    color:white;
  }
  /* アニメーション後に自動でuk-openがついてくれなくなったので仕方なくvk-modalを自分で実装 */
  .uk-modal.uk-open{
    display:block;
  }

  .title {
    & /deep/ img {
      width: 100%;
    }
  }
  .title /deep/ .VueCarousel-dot-container {
    margin-top: 0 !important;
  }
  .title /deep/ .VueCarousel-pagination {
    z-index: 10;
    top: -60px;
    position: relative;
  }
  @media (min-width: 800px){
    #layer_front_container{
      height: 380px;
    }
    #layer_front{
      height: 380px;
      /*transform:scale(1.9);*/
      transform-origin: top left;
      overflow: hidden;
      & /deep/ .product {
        transform:scale(1.9);
      }
    }
  }
</style>
